import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap"
import ModalVideo from 'react-modal-video'
import 'react-modal-video/scss/modal-video.scss';
import { createPortal } from 'react-dom';
import { Link } from "@StarberryUtils";
import playButton from "../../images/play-button.svg"
import ReactPlayer from 'react-player'
import { useLocation } from "@reach/router"
import $ from "jquery"

import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

import {
    isIOS,
    isMobileOnly,
    isBrowser,
    isMobile
} from "react-device-detect";

const playVariants = {
  hidden: {
    opacity: 0,
    scale: 0,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const ModalWindow = ({ children }) => {
    // element to which the modal will be rendered
    const el = document.createElement("div");
    // add a class to the container div for styling
    el.className = "modal-portal-container home-full-banner-video";
    useEffect(() => {
        const modalRoot = document.body;
        // append to root when the children of Modal are mounted
        modalRoot.appendChild(el);
        // do a cleanup
        return () => {
            modalRoot.removeChild(el);
        };
    }, [el]);

    return(
        createPortal(
            children,
            el
        )
    )
}


const FullCustomVideo = (props) => {
    const [isOpen, setOpen] = useState(false);

    
  const location = useLocation();
    
  const shareUrl = location.href
  
  const trackerShare = (event) => {    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Share - social icons',
      'formType': event + ' - ' +shareUrl,
      'formId': 'Share',
      'formName': 'Share',
      'formLabel': 'Share'
    });    
}
const [isPlay, setPlay] = useState(false);
const vidRef = useRef(null);
const [show, setShow] = useState(false);
const [play, setPlayvideo] = useState(true);
const [mute, setMute] = useState(true);
const [controls, setVideoControls] = useState(false);


const [showHTMLVideo, setHTMLVideo] = React.useState(false);
const pausevideo = (ref) => {
  setPlayvideo(false)
  setVideoControls(false)

}
const playvideo = (ref) => {
  setPlayvideo(true)
  setVideoControls(false)
  setTimeout(function(){ $(".modal-bg-black").hide() }, 1700);
}
const showControls = () => {
  setVideoControls(true)
}



    
    return(
        <>
            <span className="play-btn" tabIndex="0"  onClick={() => { setHTMLVideo(true); playvideo(); setShow(true); }}><motion.div variants={playVariants}><i className="icon-play-transparent"></i></motion.div></span>
            {/* <strong className="play-icn" onClick={()=> setOpen(true)} onKeyDown={()=> setOpen(true)}><motion.img variants={playVariants} src={playButton} alt="playiocn"/></strong> */}


            
            {showHTMLVideo  &&
                <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="modal-video"
                aria-labelledby="example-custom-modal-styling-title"
                backdropClassName="video-backdrop"
                className="area-guide-full-video-popup"
                >
                <Modal.Header closeButton>
                </Modal.Header>
                    <Modal.Body>

                    {isMobile &&
                    <div className="modal-bg-black">
                    </div>
                    }
                    <ReactPlayer frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen autoplay ref={vidRef} onPlay={trackerShare(props.title)} url={props.url} modestbranding="1"  controls={isMobile && isIOS ?true:false} autoplay={true} muted={isMobile && isIOS ? mute : false} playsinline={true} playing={play} onEnded={() => { setHTMLVideo(false) }} width='100%' height='100%' />
                 
                    </Modal.Body>
                </Modal>

            }
        </>
    )
}

export default FullCustomVideo

